import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSubsection } from './DetailSubsection';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { useSonarObjectReference } from '@hooks';
import { When } from 'react-if';

import { AppList, NotMonitoredLabel } from '@ui/applications';

export interface PopulatedBySectionProps {
	sonarObjectId: number;
}
export const PopulatedBySection: React.FC<PopulatedBySectionProps> = ({ sonarObjectId }) => {
	const { populatedBy } = useSonarObjectReference(sonarObjectId);
	const notMonitored = populatedBy.length === 1 && populatedBy[ 0 ] === -1;

	return (
		<FeatureBoundary feature={ FeatureFlag.DataSecurityDashboard }>
			<DetailSubsection
				className='inline-metadata'
				count={ notMonitored ? 0 : populatedBy.length }
				title={ COPY_SPECIFIC.POPULATED_BY }
				titleExtra={
					<When condition={ notMonitored }>
						<NotMonitoredLabel />
					</When>
				}>
				<When condition={ !notMonitored }>
					<AppList
						appIds={ populatedBy }
						direction='horizontal' />
				</When>
			</DetailSubsection>
		</FeatureBoundary>
	);
};
